import React from "react";

import FormInput from "../FormInput/FormInput";

export default function FormFileInput(props) {
	return <FormInput type="file" {...props} />;
}
